import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const OrderDashboardGroup = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'sort', 'sort-order');
	const dispatch = useDispatch();

	const handleChange = (e) => {
		let { value } = e.target;
		let selectedKey;
		if (value === 'Group by order') {
			selectedKey = 'order.id,desc';
		} else if (value === 'Group by brand') {
			selectedKey = 'brand,tnaScore,order.id,desc';
		} else if (value === 'Group by TNA status') {
			selectedKey = 'tnaStatus,order.id,desc';
		} else if (value === 'Sort by Buyer ETD') {
			selectedKey = 'order.deliveryDate,desc';
		} else if (value === 'Sort by Factory ETD') {
			selectedKey = 'factoryDeliveryDate,desc';
		}
		let data = {
			name: 'sort',
			type: 'text',
			key: selectedKey,
			value: value,
			identifier: 'sort-order'
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="sort-button mr-2 pr-1">
			<select
				name="sort"
				id
				onChange={handleChange}
				className={
					inputValue?.value === 'Group by order'
						? 'by-order border-0 bg-transparent'
						: 'by-tna-status border-0 bg-transparent'
				}
			>
				<option value={'Group by order'} selected={inputValue?.value === 'Group by order'}>
					Group by order
				</option>
				<option value={'Group by TNA status'} selected={inputValue?.value === 'Group by TNA status'}>
					Group by TNA status
				</option>
				<option value={'Group by brand'} selected={inputValue?.value === 'Group by brand'}>
					Group by brand
				</option>
				<option value={'Sort by Buyer ETD'} selected={inputValue?.value === 'Sort by Buyer ETD'}>
					Sort by Buyer ETD
				</option>
				<option value={'Sort by Factory ETD'} selected={inputValue?.value === 'Sort by Factory ETD'}>
					Sort by Factory ETD
				</option>
			</select>
		</div>
	);
};

export default OrderDashboardGroup;
